const delay = (time) => new Promise((resolve) => setTimeout(resolve, time))

export const polling = (promiseFunc, config = { minInterval: 1000, timeout: 10000 }) => 
  new Promise((resolve, reject) => {
    const start = Date.now()

    const run = () => {        
      if (Date.now() - start >= config.timeout) {
          return reject(new Error('Polling timeout'))
      }

      Promise.all([
          promiseFunc()
              .then((data) => ({ status: 'fulfilled', data }))
              .catch((error) => ({ status: 'rejected', data: error })),
          delay(config.minInterval),
      ])
      .then(([result]) => {
          if (result.status === 'rejected') {
              return run()
          }
          
          resolve(result.data)
      })
    }
    run()
  })
